<template>
  <v-container class="a-title-section step">
    <v-row class="full-height">
      <v-col  cols="12" class="m-col-1">
        <div class="m-title" data-aos="zoom-in">
          <p id="m-title-1">We prioritize ingredients that</p>
          <p id="m-title-2">promote skin regeneration</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.m-col-1 {
  width: 100%; /* Chiều rộng của div */
  height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
  display: flex;
  justify-content: center;
  align-items: center;
}
#m-title-1{
  font-family: 'BodoniModa-Italic';
  font-size: 25px;
}
#m-title-2 {
  font-family: BodoniModa-Bold;
  font-size: 35px;
  text-transform: uppercase;
}
.m-title {
  text-align: center;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
  }
}
</style>